import React, { useMemo } from "react";
import { MockedProvider } from "@apollo/client/testing/react";
import { MockedAuthManager } from "../../contexts/AuthManager";
import WorkerDetails from "../../screens/client/WorkerDetails";
import { buildUser, buildWorkerInfo } from "../factories";
import { GET_WORKER_INFO, REMOVE_WORKER_FROM_CLIENT } from "../../graphql/core";
import type { Meta, StoryObj } from "@storybook/react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { StoryStackNavigatorContainer } from "../display-helpers";

const Stack = createNativeStackNavigator<{
    WorkerDetails: { workerId: string };
}>();

function StoryComponent() {
    const mocks = [
        {
            request: {
                query: GET_WORKER_INFO,
                variables: () => true,
            },
            result: () => ({
                data: {
                    getWorkerInfo: buildWorkerInfo(),
                },
            }),
        },
        {
            request: {
                query: REMOVE_WORKER_FROM_CLIENT,
                variables: () => true,
            },
            result: () => ({
                data: true,
            }),
        },
    ];
    const user = useMemo(() => buildUser(), []);
    return (
        <MockedProvider mocks={mocks}>
            <MockedAuthManager user={user}>
                <StoryStackNavigatorContainer>
                    <Stack.Navigator initialRouteName="WorkerDetails">
                        <Stack.Screen
                            name="WorkerDetails"
                            component={WorkerDetails}
                            initialParams={{ workerId: "test" }}
                        />
                    </Stack.Navigator>
                </StoryStackNavigatorContainer>
            </MockedAuthManager>
        </MockedProvider>
    );
}

const meta = {
    title: "Screens/Worker details",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
